export const SLIDESHOW_SELECTION_EVENT = 'cms:slideshow-selection';

export type SlideshowSelectionDetail = { componentId: string; index: number };

export function announceSlideshowSelection(componentId: string, index: number): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(
    new CustomEvent<SlideshowSelectionDetail>(SLIDESHOW_SELECTION_EVENT, { detail: { componentId, index } })
  );
}
